export interface CommunityPost {
  id: number;
  author: string;
  avatar: string;
  role: string;
  roleColor: string;
  roleIcon: string;
  content: string;
  emotion: string;
  emotionEmoji: string;
  category: string;
  likes: number;
  replies: number;
  helpers: number;
  time: string;
  helped: boolean;
}

export interface DonationCampaign {
  id: number;
  title: string;
  description: string;
  image: string;
  raised: number;
  goal: number;
  donors: number;
  country: string;
  flag: string;
  urgent: boolean;
}

export const communityPosts: CommunityPost[] = [
  {
    id: 1,
    author: "Dr. Sarah Mitchell",
    avatar: "https://public.readdy.ai/ai/img_res/49513a229e1698cbf34721a04b9253ac.jpg",
    role: "Doctor",
    roleColor: "bg-blue-100 text-blue-600",
    roleIcon: "ri-stethoscope-line",
    content: "Free medical advice available today! If anyone has questions about child health, nutrition, or general wellness — feel free to ask. I'm here to help. 💙",
    emotion: "Helpful",
    emotionEmoji: "💙",
    category: "Medical",
    likes: 284,
    replies: 47,
    helpers: 12,
    time: "2 hours ago",
    helped: false,
  },
  {
    id: 2,
    author: "James Okafor",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20person%20portrait%20clean%20studio%20background%20friendly%20smile%20casual%20modern%20style&width=80&height=80&seq=av2&orientation=squarish",
    role: "Volunteer",
    roleColor: "bg-green-100 text-green-600",
    roleIcon: "ri-hand-heart-line",
    content: "I need help finding warm clothes for 15 infants in our local shelter. Any donations of baby clothes (0–12 months) would be life-changing. We are in Lagos, Nigeria. 🙏",
    emotion: "Hopeful",
    emotionEmoji: "🙏",
    category: "Clothing",
    likes: 521,
    replies: 89,
    helpers: 34,
    time: "4 hours ago",
    helped: false,
  },
  {
    id: 3,
    author: "Dr. Wei Zhang",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20asian%20doctor%20portrait%20white%20coat%20clean%20studio%20background%20confident%20warm%20smile%20medical%20professional&width=80&height=80&seq=av3&orientation=squarish",
    role: "Pediatrician",
    roleColor: "bg-blue-100 text-blue-600",
    roleIcon: "ri-stethoscope-line",
    content: "Reminder: Breastfeeding is the best nutrition for infants. For mothers who cannot breastfeed, please reach out — I can guide you on safe formula options. No cost, just care. ❤️",
    emotion: "Caring",
    emotionEmoji: "❤️",
    category: "Medical",
    likes: 412,
    replies: 63,
    helpers: 28,
    time: "6 hours ago",
    helped: false,
  },
  {
    id: 4,
    author: "Maria Santos",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20latin%20person%20portrait%20clean%20studio%20background%20friendly%20warm%20smile%20casual%20modern%20style&width=80&height=80&seq=av4&orientation=squarish",
    role: "Mother",
    roleColor: "bg-rose-100 text-rose-600",
    roleIcon: "ri-heart-line",
    content: "My baby is 3 months old and I'm struggling with postpartum depression. Is there anyone who has been through this and can share their experience? I feel so alone. 😢",
    emotion: "Struggling",
    emotionEmoji: "😢",
    category: "Mental Health",
    likes: 893,
    replies: 142,
    helpers: 67,
    time: "8 hours ago",
    helped: false,
  },
  {
    id: 5,
    author: "Robert Chen",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20asian%20person%20portrait%20clean%20studio%20background%20friendly%20smile%20business%20casual%20modern%20style&width=80&height=80&seq=av5&orientation=squarish",
    role: "Donor",
    roleColor: "bg-amber-100 text-amber-600",
    roleIcon: "ri-gift-line",
    content: "Just donated $500 to the infant milk fund! Seeing these babies smile makes it all worth it. I encourage everyone who can afford it to give even a little. Every dollar counts! 🌟",
    emotion: "Joyful",
    emotionEmoji: "🌟",
    category: "Donation",
    likes: 1240,
    replies: 98,
    helpers: 0,
    time: "1 day ago",
    helped: false,
  },
  {
    id: 6,
    author: "Dr. Amina Hassan",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20african%20doctor%20portrait%20white%20coat%20clean%20studio%20background%20confident%20warm%20smile%20medical%20professional&width=80&height=80&seq=av6&orientation=squarish",
    role: "Nutritionist",
    roleColor: "bg-teal-100 text-teal-600",
    roleIcon: "ri-leaf-line",
    content: "FREE nutrition consultation for mothers with infants under 1 year. I specialize in infant feeding and malnutrition prevention. DM me or reply here. Together we can save lives. 🌱",
    emotion: "Determined",
    emotionEmoji: "🌱",
    category: "Nutrition",
    likes: 678,
    replies: 115,
    helpers: 45,
    time: "1 day ago",
    helped: false,
  },
];

export const donationCampaigns: DonationCampaign[] = [
  {
    id: 1,
    title: "Milk for 1,000 Infants in Somalia",
    description: "Severe drought has left thousands of infants without access to nutrition. Your donation provides life-saving formula milk for babies aged 0–12 months.",
    image: "https://readdy.ai/api/search-image?query=innocent%20baby%20infant%20portrait%20beautiful%20eyes%20warm%20light%20soft%20background%20hope%20love%20care%20emotional%20touching%20photography&width=600&height=400&seq=don1&orientation=landscape",
    raised: 84200,
    goal: 120000,
    donors: 2841,
    country: "Somalia",
    flag: "🇸🇴",
    urgent: true,
  },
  {
    id: 2,
    title: "Warm Clothes for Winter Babies in Ukraine",
    description: "Thousands of displaced infants in Ukraine face a harsh winter without proper clothing. Help us provide warm clothes, blankets, and essentials.",
    image: "https://readdy.ai/api/search-image?query=baby%20infant%20wrapped%20in%20warm%20blanket%20cozy%20soft%20light%20beautiful%20peaceful%20sleeping%20hope%20love%20care%20touching%20photography&width=600&height=400&seq=don2&orientation=landscape",
    raised: 62500,
    goal: 80000,
    donors: 1920,
    country: "Ukraine",
    flag: "🇺🇦",
    urgent: true,
  },
  {
    id: 3,
    title: "Medical Care for Newborns in Yemen",
    description: "Newborns in conflict zones need urgent medical attention. Fund vaccines, vitamins, and basic healthcare for the most vulnerable infants.",
    image: "https://readdy.ai/api/search-image?query=newborn%20baby%20infant%20tiny%20hands%20feet%20soft%20warm%20light%20beautiful%20peaceful%20hope%20love%20care%20touching%20emotional%20photography&width=600&height=400&seq=don3&orientation=landscape",
    raised: 45800,
    goal: 100000,
    donors: 1340,
    country: "Yemen",
    flag: "🇾🇪",
    urgent: false,
  },
  {
    id: 4,
    title: "Baby Formula Fund — Sub-Saharan Africa",
    description: "Malnutrition affects 1 in 3 infants in Sub-Saharan Africa. Your donation directly funds baby formula distribution to mothers who cannot breastfeed.",
    image: "https://readdy.ai/api/search-image?query=african%20baby%20infant%20beautiful%20smile%20warm%20light%20soft%20background%20joy%20hope%20love%20care%20touching%20emotional%20photography&width=600&height=400&seq=don4&orientation=landscape",
    raised: 31200,
    goal: 60000,
    donors: 987,
    country: "Africa",
    flag: "🌍",
    urgent: false,
  },
];

export const emotions = [
  { emoji: "😊", label: "Happy" },
  { emoji: "💙", label: "Helpful" },
  { emoji: "🙏", label: "Hopeful" },
  { emoji: "❤️", label: "Caring" },
  { emoji: "😢", label: "Struggling" },
  { emoji: "🌟", label: "Joyful" },
  { emoji: "🌱", label: "Determined" },
  { emoji: "😰", label: "Worried" },
  { emoji: "🤗", label: "Grateful" },
  { emoji: "💪", label: "Strong" },
];

export const roles = [
  { label: "Doctor", icon: "ri-stethoscope-line", color: "bg-blue-100 text-blue-600" },
  { label: "Pediatrician", icon: "ri-stethoscope-line", color: "bg-blue-100 text-blue-600" },
  { label: "Nutritionist", icon: "ri-leaf-line", color: "bg-teal-100 text-teal-600" },
  { label: "Volunteer", icon: "ri-hand-heart-line", color: "bg-green-100 text-green-600" },
  { label: "Mother", icon: "ri-heart-line", color: "bg-rose-100 text-rose-600" },
  { label: "Father", icon: "ri-heart-line", color: "bg-rose-100 text-rose-600" },
  { label: "Donor", icon: "ri-gift-line", color: "bg-amber-100 text-amber-600" },
  { label: "Social Worker", icon: "ri-community-line", color: "bg-purple-100 text-purple-600" },
  { label: "Teacher", icon: "ri-book-open-line", color: "bg-indigo-100 text-indigo-600" },
  { label: "General Public", icon: "ri-user-line", color: "bg-gray-100 text-gray-600" },
];
